import { render } from "./PrintGate.vue?vue&type=template&id=96befc66&scoped=true"
import script from "./PrintGate.vue?vue&type=script&lang=js"
export * from "./PrintGate.vue?vue&type=script&lang=js"

import "./PrintGate.vue?vue&type=style&index=0&id=96befc66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96befc66"]])

export default __exports__